<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact data-table">
        <thead>
          <tr>
            <th>{{ $t("product.自定义名称") }}</th>
            <th>{{ $t("product.1688账号名") }}</th>
            <th>{{ $t("product.授权状态") }}</th>
            <th>{{ $t("product.授权过期时间") }}</th>
            <th class="wd-lg-100">{{ $t("product.是否启用") }}</th>
            <th class="wd-lg-100">{{ $t("product.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <span class="tx-white">{{ item.name }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.resourceOwner }}</span>
            </td>
            <td class="valign-middle">
              <span :class="item.authStatus | statusClass">{{
                $t(authStatusArr[item.authStatus])
              }}</span>
              <a
                v-if="item.errorLog"
                class="tx-info"
                href="javascript:;"
                @click="openErrorLog(item.errorLog)"
              >
                <i class="icon ion-chatbox-working"></i>
              </a>
            </td>
            <td class="valign-middle">{{ item.refreshTokenTimeout }}</td>
            <td class="valign-middle">
              <span :class="item.status | statusClass">{{
                $t(authUseStatusArr[item.status])
              }}</span>
            </td>
            <td class="valign-middle">
              <div v-if="isSysRights('Account1688.changeStatus')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="changeStatus(item.id)"
                  >{{
                    item.status == 1 ? $t("product.停用") : $t("product.启用")
                  }}</a
                >
              </div>
              <div v-if="isSysRights('Account1688.create1688Account')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="change1688Auth(item)"
                  >{{ $t("product.修改") }}</a
                >
              </div>
              <div v-if="isSysRights('Account1688.getAliCode')">
                <a class="tx-info" href="javascript:;" @click="auth(item)">{{
                  $t("product.授权")
                }}</a>
              </div>
              <div v-if="isSysRights('Account1688.delAccount')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="openDelConfirm(item.id)"
                  >{{ $t("product.删除") }}</a
                >
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="6">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("product.没有符合条件的账号授权") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
      authStatusArr: arrDict.auth1688Status,
      authUseStatusArr: arrDict.auth1688UseStatus,
    };
  },
  filters: {
    statusClass: function (val) {
      switch (val) {
        case "1":
          return "tx-success";
          break;
        case "2":
          return "tx-gray";
          break;
        case "3":
          return "tx-danger";
          break;
      }
    },
  },
  methods: {
    changeStatus(id) {
      this.$emit("changeStatus", id);
    },
    openDelConfirm(id) {
      this.$emit("openDelConfirm", id);
    },
    auth(item) {
      this.$emit("auth", item);
    },
    change1688Auth(item) {
      this.$emit("change1688Auth", item);
    },
    openErrorLog(errorLog) {
      this.$emit("openErrorLog", errorLog);
    },
  },
};
</script>